import apiClient from './api'

export default {
    async get (id) {
        return await apiClient.get(`/cms/items/${id}`)
    },
    async getAll (params = {}) {
        params.paginate = false
        return await apiClient.get('/cms/items', { params })
    },
    async paginate (params) {
        params.paginate = true
        params.perPage = params.itemsPerPage
        const result = await apiClient.get('/cms/items', { params })
        result.data.total = Number(result.data.total)
        return result
    },
    async add (params) {
        return await apiClient.post('/cms/items', apiClient.objectToFormData(params), {
            headers: { 'Content-Type': 'multipart/form-data' }
        })
    },
    async edit (id, params) {
        return await apiClient.put(`/cms/items/${id}`, apiClient.objectToFormData(params), {
            headers: { 'Content-Type': 'multipart/form-data' }
        })
    },
    async delete (id) {
        return await apiClient.delete(`/cms/items/${id}`)
    },
}